import { FormHelperText, Stack } from '@mui/material';
import _ from 'lodash';

import { api } from 'common';

import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockSelectField } from '../../../ConfigFields/SelectField';

export function UpdatePatientUploadFormFields() {
  return (
    <Stack gap={2}>
      <BlockValueTemplateField
        fieldName="config.patientUploadId"
        label="Patient Upload ID"
        helperText="Enter the reference to the patient upload to update"
        placeholder="e.g. {{block.data.patientUploadId}}"
      />
      <FormHelperText>The Patient Upload ID should be a valid UUID string</FormHelperText>
      <BlockSelectField
        label="Document Type"
        fieldName="config.documentType"
        options={Object.values(api.PatientUpload.DocumentType).map((documentType) => ({
          label: _.startCase(_.toLower(documentType)),
          value: documentType,
        }))}
      />
      <BlockSelectField
        label="Status"
        fieldName="config.status"
        options={Object.values(api.PatientUpload.UploadStatus).map((status) => ({
          label: _.startCase(_.toLower(status)),
          value: status,
        }))}
      />
      <BlockValueTemplateField
        fieldName="config.existingDocument"
        label="Existing Document"
        helperText='Whether the document already exists on file - "true" or "false"'
        placeholder="e.g. true"
      />
      <BlockValueTemplateField
        fieldName="config.existingDocumentUploadDate"
        label="Existing Document Upload Date"
        helperText="The date the existing document was last updated in the EHR (ISO 8601)"
        placeholder="e.g. 2025-05-13 or null to clear"
      />
    </Stack>
  );
}
